import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import {
  cameraControl,
  startLiveStream,
  stopLiveStream,
  cameraControlGoHome,
  cameraControlSetHome,
} from "../../global/utility/Utils";
import {
  iframeStyle,
  style,
  videoWrapperCustom,
  videoWrapperDefault,
} from "../constants/videoPlayerConstants";
import { getStreamProxyEndPoint } from "../../configuration";

import { Modal, ModalBody } from "@vds/modals";
import { Body } from "@vds/typography";
import { Notification } from "@vds/notifications";
import { Icon } from "@vds/icons";
import IconButton from "@mui/material/IconButton";
import { Loader } from "@vds/loaders";
import { Button } from "@vds/buttons";
import { ButtonGroup } from "@vds/buttons";
import { getResourceIdentifierForDevice } from "../../global/utility/Utils";
import { ReactComponent as Rectangle } from "../../assets/videoBackground.svg";
import People from "../../assets/no-livevideo.png";
import { useDispatch, useSelector } from "react-redux";
import { showNotificationBanner } from "../../store/actions";
import "../../styles/global.css";
import ErrorTemplate from "./errorTemplate/ErrorTemplate";
import { TEXT } from "../constants/errorTemplateConstants";
import { Box } from "@mui/material";

export const PlayHLSVideo = ({
  cameraQrcode = undefined,
  liveFeedStyle,
  liveFeedStream,
  cameraRefidType = undefined,
  isCustomWrapper = false,
}) => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const playerRef = useRef(null);
  let { state } = useLocation();

  const deviceList = useSelector((state) => state?.deviceReducer?.deviceList);
  const getCompanionName = () => {
    if (deviceList && Array.isArray(deviceList)) {
      return deviceList.find((i) => i.id === liveFeedStream?.parentdeviceid)
        ?.name;
    }
    return "";
  };

  const [videoUrl, setVideoUrl] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const [tableLoading, setTableLoading] = useState(false); // Show loader initially
  const [error, setError] = useState(false);
  const id = cameraQrcode
    ? cameraQrcode
    : state?.data?.refid || state?.evidence?.sourceId || cameraQrcode; //dynamic
  const refidType = cameraRefidType
    ? cameraRefidType
    : state?.data?.refidtype || cameraRefidType;
  const cameraId = state?.data?.id;
  const cameraType = state?.data?.customdata?.ptz || "none";
  const dispatch = useDispatch();
  const [isCCDLimitModalVisible, setIsCCDLimitModalVisible] = useState(false);
  const [selectedCompanionName, setSelectedCompanionName] =
    useState("Companion Device");
  const [refreshLoader, setRefreshLoader] = useState(false);
  const playVideo = async (e, isRefresh) => {
    if(isRefresh) {
      setError(false);
      setRefreshLoader(true);
    }

    const startLiveStreamResponse = await startLiveStream(
      liveFeedStream,
      activeSession
    );
    try {
      setRefreshLoader(false);
      setTableLoading(true);
      if (startLiveStreamResponse?.response?.error) {
        setVideoUrl(People);
        setAuthToken("");
        setError(true);
        if (startLiveStreamResponse?.status === 429) {
          setIsCCDLimitModalVisible(true);
          const notificationInfo = {
            type: "max amount of streams",
            priority: "critical",
            data: {
              name: getCompanionName(),
            },
            showNotification: true,
          };
          dispatch(showNotificationBanner(notificationInfo));
        }
      } else if (!startLiveStreamResponse.error) {
        setIsCCDLimitModalVisible(false);
        setVideoUrl(startLiveStreamResponse?.response.url);
        setAuthToken(startLiveStreamResponse?.response.authtoken);
        setError(false);
      }
    } catch (e) {
      console.log("Error starting live stream", startLiveStreamResponse);
      setError(true);
      setVideoUrl(People);
      setAuthToken("");
    } finally {
      setRefreshLoader(false);
      setTableLoading(false);
    }
  };

  // const stopVideo = async (e) => {
  //   const stopLiveStreamResponse = await stopLiveStream(
  //     liveFeedStream,
  //     activeSession
  //   );
  //   try {
  //     if (!stopLiveStreamResponse.error) {
  //       setVideoUrl("");
  //     }
  //   } catch (e) {
  //     console.log("Error stopping live stream", stopLiveStreamResponse);
  //     // TODO: remove this part once the API is returning success
  //     setVideoUrl("");
  //   }
  // };

  const handleZoomIn = async () => {
    const deviceInfo = { refidtype: refidType, refid: id, id: cameraId };
    const resourceIdentifier = getResourceIdentifierForDevice(deviceInfo);
    const zoomInResponse = await cameraControl(
      resourceIdentifier,
      { z: 0.005 },
      { z1: 0.1 },
      activeSession
    );
    if (zoomInResponse.status !== 200) {
      console.log("Error handling zoom in command", zoomInResponse);
    }
  };

  const handleZoomOut = async () => {
    const deviceInfo = { refidtype: refidType, refid: id, id: cameraId };
    const resourceIdentifier = getResourceIdentifierForDevice(deviceInfo);
    const zoomOutResponse = await cameraControl(
      resourceIdentifier,
      { z: -0.005 },
      { z1: 0.1 },
      activeSession
    );
    if (zoomOutResponse.status !== 200) {
      console.log("Error handling zoom out command", zoomOutResponse);
    }
  };

  const handleMoveLeft = async () => {
    const deviceInfo = { refidtype: refidType, refid: id, id: cameraId };
    const resourceIdentifier = getResourceIdentifierForDevice(deviceInfo);
    const tiltLeftResponse = await cameraControl(
      resourceIdentifier,
      { x: 0.05 },
      { x1: 0.1 },
      activeSession
    );
    if (tiltLeftResponse.status !== 200) {
      console.log("Error handling tilt left command", tiltLeftResponse);
    }
  };

  const handleMoveRight = async () => {
    const deviceInfo = { refidtype: refidType, refid: id, id: cameraId };
    const resourceIdentifier = getResourceIdentifierForDevice(deviceInfo);
    const tiltRightResponse = await cameraControl(
      resourceIdentifier,
      { x: -0.05 },
      { x1: 0.1 },
      activeSession
    );
    if (tiltRightResponse.status !== 200) {
      console.log("Error handling tilt right command", tiltRightResponse);
    }
  };

  const handleMoveUp = async () => {
    const deviceInfo = { refidtype: refidType, refid: id, id: cameraId };
    const resourceIdentifier = getResourceIdentifierForDevice(deviceInfo);
    const tiltUpResponse = await cameraControl(
      resourceIdentifier,
      { y: -0.1 },
      { y1: 0.1 },
      activeSession
    );
    if (tiltUpResponse.status !== 200) {
      console.log("Error handling tilt up command", tiltUpResponse);
    }
  };

  const handleMoveDown = async () => {
    const deviceInfo = { refidtype: refidType, refid: id, id: cameraId };
    const resourceIdentifier = getResourceIdentifierForDevice(deviceInfo);
    const tiltDownResponse = await cameraControl(
      resourceIdentifier,
      { y: 0.1 },
      { y1: 0.1 },
      activeSession
    );
    if (tiltDownResponse.status !== 200) {
      console.log("Error handling tilt down command", tiltDownResponse);
    }
  };

  const handleSetHome = async () => {
    const deviceInfo = { refidtype: refidType, refid: id, id: cameraId };
    const resourceIdentifier = getResourceIdentifierForDevice(deviceInfo);
    const setHomeResponse = await cameraControlSetHome(
      resourceIdentifier,
      activeSession
    );
    if (setHomeResponse.status !== 200) {
      console.log("Error handling set home command", setHomeResponse);
    }
  };

  const handleGoHome = async () => {
    const deviceInfo = { refidtype: refidType, refid: id, id: cameraId };
    const resourceIdentifier = getResourceIdentifierForDevice(deviceInfo);
    const goHomeResponse = await cameraControlGoHome(
      resourceIdentifier,
      activeSession
    );
    if (goHomeResponse.status !== 200) {
      console.log("Error handling go home command", goHomeResponse);
    }
  };

  useEffect(() => {
    const iframe = document.getElementById("inlineFrameExample");
    if (typeof liveFeedStream !== "undefined") {
      playVideo(true);
      if (iframe) {
        iframe.onload = () => {
          playVideo(true);
        };
        iframe.onerror = () => {
          setError(true);
          setTableLoading(false);
          playVideo(false);
          console.log("Video failed to load.");
        };
      }
    }

    return () => {
      // if (typeof liveFeedStream !== "undefined") {
      //   stopVideo(true);
      // }
      setTableLoading(false);
      if (playerRef.current) {
        playerRef.current.reset();
      }
    };
  }, [liveFeedStream, activeSession?.sessionToken]);

const renderVideoContent = () => {
  if (error) {
    return <Box sx={{height: "372px"}}>
      <ErrorTemplate 
        title={id ? TEXT.LIVE_STREAM_ERROR : TEXT.CAMERA_NOT_AVAILABLE_ERROR} 
        description={id ? TEXT.LIVE_STREAM_DESC : TEXT.CAMERA_NOT_AVAILABLE_DESC} 
        testId="devices_video_error"
        onRefresh={() => playVideo(null, true)}
      />
    </Box>
  }

  if(refreshLoader) {
    return (
      <Box sx={{ height: "372px", position: "relative" }}>
        <Loader active={refreshLoader} fullscreen={false} />
      </Box>
    );
  }

  if (tableLoading || !videoUrl) {
    return (
      <div
        id="liveStreamLoader"
        style={{
          height: liveFeedStyle?.height || "372px",
          width: liveFeedStyle?.width || "100%"
        }}
      >
        <Loader active fullscreen={false} surface="light" />
      </div>
    );
  }

  // Build video stream URL based on session mode
  const getVideoStreamUrl = () => {
    const isRedisMode = activeSession?.isRedisMode === true;

    if (isRedisMode) {
      // Redis mode: call event-manager proxy with streamId only.
      // The proxy fetches the auth token from the Redis session server-side.
      const streamId = videoUrl?.split('/').filter(Boolean).pop();
      return getStreamProxyEndPoint(streamId, null, null);
    } else {
      // Legacy mode: Direct mb-stream URL with token in URL.
      const token = authToken || activeSession?.sessionToken;
      if (!token) {
        console.error('No valid authentication token available for video stream');
        return null;
      }
      return `${videoUrl}?auth=${token}`;
    }
  };

  return (
    <iframe
      sandbox="allow-scripts allow-forms allow-pointer-lock allow-same-origin"
      id="inlineFrameExample"
      title="Video Stream"
      width={liveFeedStyle?.width || "100%"}
      height={liveFeedStyle?.height || "372"}
      allowFullScreen={true}
      loading="eager"
      allow="display-capture"
      src={getVideoStreamUrl()}
    />
  );
};

  return (
    <>
      <Modal
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        opened={isCCDLimitModalVisible}
        hideCloseButton={false}
        closeButton={
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px",
            }}
            onClick={() => {
              //setLicenseSwitchMessage("");
              setIsCCDLimitModalVisible(false);
            }}
          >
            <Icon name="close" />
          </div>
        }
      >
        <ModalBody>
          <div style={{ overflow: "hidden" }}>
            <br />
            <Body
              size="medium"
              viewport="desktop"
              primitive="span"
              color="#000000"
            >
              <Notification
                type="error"
                title={`${selectedCompanionName} is at capacity limit`}
                subtitle="No more Stream can be relayed to this device."
                disableFocus={false}
                hideCloseButton={true}
              />
            </Body>
            <div style={{ marginTop: "30px" }}>
              <ButtonGroup
                viewport={"desktop"}
                gap="16px"
                alignment="center"
                data={[
                  {
                    children: "Close",
                    size: "large",
                    use: "primary",
                    width: "100%",
                    onClick: () => {
                      setIsCCDLimitModalVisible(false);
                    },
                  },
                ]}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>
      <div
        style={
          liveFeedStyle
            ? liveFeedStyle
            : isCustomWrapper
            ? videoWrapperCustom
            : videoWrapperDefault
        }
      >
        {renderVideoContent()}
        {/* {!tableLoading && error && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              cursor: "not-allowed",
            }}
          >
            <Icon name="no-video" size="50px" color="#FFFFFF" />
          </div>
        )} */}
      </div>
      {/* <br />
      <div style={{ display: "flex" }}>
        {videoUrl !== "" &&
          (cameraType === "basic" || cameraType === "extended") && (
            <>
              <IconButton
                onClick={() => {
                  handleZoomIn();
                }}
              >
                <Icon name="zoom-in" size="XLarge" color="#000000" />
              </IconButton>
              <IconButton
                onClick={() => {
                  handleZoomOut();
                }}
              >
                <Icon name="zoom-out" size="XLarge" color="#000000" />
              </IconButton>
              <IconButton
                onClick={() => {
                  handleMoveLeft();
                }}
              >
                <Icon name="left-caret" size="XLarge" color="#000000" />
              </IconButton>
              <IconButton
                onClick={() => {
                  handleMoveRight();
                }}
              >
                <Icon name="right-caret" size="XLarge" color="#000000" />
              </IconButton>
              <IconButton
                onClick={() => {
                  handleMoveUp();
                }}
              >
                <Icon name="up-caret" size="XLarge" color="#000000" />
              </IconButton>
              <IconButton
                onClick={() => {
                  handleMoveDown();
                }}
              >
                <Icon name="down-caret" size="XLarge" color="#000000" />
              </IconButton>
            </>
          )}
        {videoUrl !== "" && cameraType === "extended" && (
          <>
            <IconButton
              onClick={() => {
                handleGoHome();
              }}
            >
              <Icon name="home" size="XLarge" color="#000000" />
            </IconButton>
            <Button
              variant="text"
              size="small"
              onClick={() => {
                handleSetHome();
              }}
            >
              Set Home
            </Button>
          </>
        )}
      </div> */}
    </>
  );
};
